import React from 'react'
import './Footer.scss'


export default () => {
	return (
		<div className="Footer">
			<div className="inner">
				<p>Artwork, design and code by <a href="//bigfish.no">Big Fish</a></p>
			</div>
		</div>
	)
}